import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client';

/**
 * Apollo client for the payment-service GraphQL endpoint.
 *
 * The auth-token getter is injected by the consuming app so this lib stays
 * decoupled from the app's specific store implementation.
 */
export interface PaymentClientConfig {
  /** GraphQL endpoint URL — usually from VITE_PAYMENT_SERVICE_URL */
  uri: string;
  /** Returns the current Bearer token, or null for guest requests */
  getAuthToken: () => string | null;
  /** Whether to send credentials (cookies) on requests — true if/when httpOnly cookies are introduced */
  withCredentials?: boolean;
}

export function createPaymentClient(config: PaymentClientConfig): ApolloClient {
  const link = new HttpLink({
    uri: config.uri,
    credentials: config.withCredentials ? 'include' : 'same-origin',
    fetch: (uri, options) => {
      const token = config.getAuthToken();
      const headers = new Headers(options?.headers);
      if (token) headers.set('authorization', `Bearer ${token}`);
      return fetch(uri, { ...options, headers });
    },
  });

  return new ApolloClient({
    link,
    cache: new InMemoryCache(),
  });
}
